import styled from 'styled-components';

export const StyledLabel = styled.label<{ $inlinePresent?: boolean }>`
    display: ${({ $inlinePresent }) => ($inlinePresent ? 'flex' : 'block')};
    ${({ $inlinePresent }) => ($inlinePresent ? 'align-items: center;' : '')}
    vertical-align: bottom;
    margin-bottom: ${({ $inlinePresent, theme }) => ($inlinePresent ? '0' : theme.space[4])};
    color: ${({ theme }) => theme.colors.label.text};
`;
